// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InfoCircleOutlinedSvg from "@fishx/icons-svg/es/asn/InfoCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var InfoCircleOutlined = function InfoCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: InfoCircleOutlinedSvg
  }));
};

InfoCircleOutlined.displayName = 'InfoCircleOutlined';
export default React.forwardRef(InfoCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/InfoCircleOutlined.js
// module id = 2965
// module chunks = 0